export default function ServiceAreaNavigator() {
  const neighborhoods = [
    { name: 'Sunland Park', count: 87, icon: 'ri-sun-line' },
    { name: 'Westside', count: 142, icon: 'ri-map-pin-line' },
    { name: 'Northeast', count: 156, icon: 'ri-compass-line' },
    { name: 'East El Paso', count: 98, icon: 'ri-road-map-line' },
    { name: 'Lower Valley', count: 76, icon: 'ri-landscape-line' },
    { name: 'Central', count: 134, icon: 'ri-building-line' },
    { name: 'Mission Valley', count: 65, icon: 'ri-community-line' },
    { name: 'Upper Valley', count: 54, icon: 'ri-home-smile-line' }
  ];

  return (
    <section id="neighborhoods" className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Browse Contractors by Your El Paso Neighborhood
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Finding the right contractor in El Paso starts with knowing your neighborhood. Our comprehensive directory connects you with trusted professionals who understand the unique needs of your specific area, from Sunland Park's desert climate challenges to the Lower Valley's irrigation requirements and Northeast El Paso's modern home designs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {neighborhoods.map((area) => (
            <a
              key={area.name}
              href={`#${area.name.toLowerCase().replace(/\s+/g, '-')}`}
              className="group bg-white rounded-xl p-6 hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-500 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-lg group-hover:bg-teal-600 transition-colors">
                  <i className={`${area.icon} text-2xl text-teal-600 group-hover:text-white transition-colors`}></i>
                </div>
                <span className="text-sm font-medium text-gray-500">{area.count} pros</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                {area.name}
              </h3>
              <p className="text-sm text-gray-600">
                Find local contractors serving {area.name}
              </p>
            </a>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-xl p-8 border border-gray-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Why Neighborhood Matters for Your El Paso Home Project
          </h3>
          <div className="grid md:grid-cols-2 gap-6 text-sm text-gray-700 leading-relaxed">
            <div>
              <p className="mb-4">
                <strong className="text-gray-900">Local Building Codes &amp; Permits:</strong> El Paso contractors familiar with your neighborhood understand specific zoning regulations, HOA requirements, and permit processes that vary across different areas of the city. Whether you're in the historic Sunset Heights district or newer developments in the Far East, local expertise ensures compliance and smooth project execution.
              </p>
              <p>
                <strong className="text-gray-900">Climate-Specific Solutions:</strong> El Paso's desert climate presents unique challenges. Contractors serving the Westside understand wind exposure issues, while those in the Lower Valley know about soil conditions and foundation requirements. Temperature extremes, monsoon preparation, and UV-resistant materials are considerations that experienced local contractors factor into every project.
              </p>
            </div>
            <div>
              <p className="mb-4">
                <strong className="text-gray-900">Faster Response Times:</strong> When you hire contractors who regularly work in your neighborhood, you benefit from quicker response times for estimates, emergency repairs, and project completion. They're already familiar with local suppliers, have established relationships with inspectors, and can navigate your area efficiently.
              </p>
              <p>
                <strong className="text-gray-900">Community Reputation:</strong> Neighborhood-based contractors stake their reputation on local work. They're more invested in quality results because their business depends on word-of-mouth referrals within the community. You can easily verify their work by seeing completed projects in your own neighborhood.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
